import { firebaseCloudFunctionService } from '@/libs/api';
import type { AxiosResponse } from 'axios';

export const PLAYER_SESSION_ENDPOINTS = {
  LIST_SESSIONS: '/sortFilterSearchSessions',
  END_SESSION: '/removeCoachFromSession',
  UPDATE_PLAYER_PROGRESS: '/v2/updatePlayerProgress',
  // iOS: "\(Endpoints.apiURL)/checkPlayerProgressContains/attempt"
  CHECK_SESSION_FOR_PLAYER_PROGRESS: '/checkPlayerProgressContains/attempt',
} as const;

const TOTAL_SESSION_ROSTER_HEADER = 'x-total-session-roster';
const TOTAL_NEEDS_CLUBS_HEADER = 'x-total-needs-clubs';
const TOTAL_PINS_ARCHIVED_HEADER = 'x-total-pins-archived';

function parseTotalSessionRosterHeader(headers: AxiosResponse['headers']): number | null {
  const raw = headers?.[TOTAL_SESSION_ROSTER_HEADER] ?? headers?.['X-Total-Session-Roster'];
  if (raw == null || raw === '') return null;
  const s = Array.isArray(raw) ? raw[0] : String(raw);
  const n = Number(s);
  return Number.isFinite(n) ? n : null;
}

function parseTotalNeedsClubsHeader(headers: AxiosResponse['headers']): number | null {
  const raw = headers?.[TOTAL_NEEDS_CLUBS_HEADER] ?? headers?.['X-Total-Needs-Clubs'];
  if (raw == null || raw === '') return null;
  const s = Array.isArray(raw) ? raw[0] : String(raw);
  const n = Number(s);
  return Number.isFinite(n) ? n : null;
}

function parseTotalPinsArchivedHeader(headers: AxiosResponse['headers']): number | null {
  const raw = headers?.[TOTAL_PINS_ARCHIVED_HEADER] ?? headers?.['X-Total-Pins-Archived'];
  if (raw == null || raw === '') return null;
  const s = Array.isArray(raw) ? raw[0] : String(raw);
  const n = Number(s);
  return Number.isFinite(n) ? n : null;
}

// TODO: remove mock data once the API returns real pins/attempts
export const FULL_PINS: playerSession.Pin[] = [
  { name: 'Putting', levelNumber: 1, pinPicture: 'LV1_Putting.svg' },
  { name: 'Scoring', levelNumber: 1, pinPicture: 'LV1_Score.svg' },
  { name: 'Knowledge', levelNumber: 1, pinPicture: 'LV1_Know.svg' },
  { name: 'Full Swing', levelNumber: 1, pinPicture: 'LV1_Full_Swing.svg' },
  { name: 'Around The Green', levelNumber: 1, pinPicture: 'LV1_ATG.svg' },
  { name: 'Overall', levelNumber: 1, pinPicture: 'LV1_Overall.svg' },
  { name: 'Putting', levelNumber: 2, pinPicture: 'LV2_Putting.svg' },
  { name: 'Scoring', levelNumber: 2, pinPicture: 'LV2_Score.svg' },
  { name: 'Knowledge', levelNumber: 2, pinPicture: 'LV2_Know.svg' },
  { name: 'Full Swing', levelNumber: 2, pinPicture: 'LV2_Full_Swing.svg' },
  { name: 'Around The Green', levelNumber: 2, pinPicture: 'LV2_ATG.svg' },
  { name: 'Overall', levelNumber: 2, pinPicture: 'LV2_Overall.svg' },
  { name: 'Putting', levelNumber: 3, pinPicture: 'LV3_Putting.svg' },
  { name: 'Scoring', levelNumber: 3, pinPicture: 'LV3_Score.svg' },
  { name: 'Knowledge', levelNumber: 3, pinPicture: 'LV3_Know.svg' },
  { name: 'Full Swing', levelNumber: 3, pinPicture: 'LV3_Full_Swing.svg' },
  { name: 'Around The Green', levelNumber: 3, pinPicture: 'LV3_ATG.svg' },
  { name: 'Overall', levelNumber: 3, pinPicture: 'LV3_Overall.svg' },
  { name: 'Putting', levelNumber: 4, pinPicture: 'LV4_Putting.svg' },
  { name: 'Scoring', levelNumber: 4, pinPicture: 'LV4_Score.svg' },
  { name: 'Knowledge', levelNumber: 4, pinPicture: 'LV4_Know.svg' },
  { name: 'Full Swing', levelNumber: 4, pinPicture: 'LV4_Full_Swing.svg' },
  { name: 'Around The Green', levelNumber: 4, pinPicture: 'LV4_ATG.svg' },
  { name: 'Overall', levelNumber: 4, pinPicture: 'LV4_Overall.svg' },
  { name: 'Putting', levelNumber: 5, pinPicture: 'LV5_Putting.svg' },
  { name: 'Scoring', levelNumber: 5, pinPicture: 'LV5_Score.svg' },
  { name: 'Knowledge', levelNumber: 5, pinPicture: 'LV5_Know.svg' },
  { name: 'Full Swing', levelNumber: 5, pinPicture: 'LV5_Full_Swing.svg' },
  { name: 'Around The Green', levelNumber: 5, pinPicture: 'LV5_ATG.svg' },
  { name: 'Overall', levelNumber: 5, pinPicture: 'LV5_Overall.svg' },
  { name: 'Putting', levelNumber: 6, pinPicture: 'LV6_Putting.svg' },
  { name: 'Scoring', levelNumber: 6, pinPicture: 'LV6_Score.svg' },
  { name: 'Knowledge', levelNumber: 6, pinPicture: 'LV6_Know.svg' },
  { name: 'Full Swing', levelNumber: 6, pinPicture: 'LV6_Full_Swing.svg' },
  { name: 'Around The Green', levelNumber: 6, pinPicture: 'LV6_ATG.svg' },
  { name: 'Overall', levelNumber: 6, pinPicture: 'LV6_Overall.svg' },
  { name: 'Putting', levelNumber: 7, pinPicture: 'LV7_Putting.svg' },
  { name: 'Scoring', levelNumber: 7, pinPicture: 'LV7_Score.svg' },
  { name: 'Knowledge', levelNumber: 7, pinPicture: 'LV7_Know.svg' },
  { name: 'Full Swing', levelNumber: 7, pinPicture: 'LV7_Full_Swing.svg' },
  { name: 'Around The Green', levelNumber: 7, pinPicture: 'LV7_ATG.svg' },
  { name: 'Overall', levelNumber: 7, pinPicture: 'LV7_Overall.svg' },
  { name: 'Putting', levelNumber: 8, pinPicture: 'LV8_Putting.svg' },
  { name: 'Scoring', levelNumber: 8, pinPicture: 'LV8_Score.svg' },
  { name: 'Knowledge', levelNumber: 8, pinPicture: 'LV8_Know.svg' },
  { name: 'Full Swing', levelNumber: 8, pinPicture: 'LV8_Full_Swing.svg' },
  { name: 'Around The Green', levelNumber: 8, pinPicture: 'LV8_ATG.svg' },
  { name: 'Overall', levelNumber: 8, pinPicture: 'LV8_Overall.svg' },
  { name: 'Putting', levelNumber: 9, pinPicture: 'LV9_Putting.svg' },
  { name: 'Scoring', levelNumber: 9, pinPicture: 'LV9_Score.svg' },
  { name: 'Knowledge', levelNumber: 9, pinPicture: 'LV9_Know.svg' },
  { name: 'Full Swing', levelNumber: 9, pinPicture: 'LV9_Full_Swing.svg' },
  { name: 'Around The Green', levelNumber: 9, pinPicture: 'LV9_ATG.svg' },
  { name: 'Overall', levelNumber: 9, pinPicture: 'LV9_Overall.svg' },
  { name: 'Putting', levelNumber: 10, pinPicture: 'LV10_Putting.svg' },
  { name: 'Scoring', levelNumber: 10, pinPicture: 'LV10_Score.svg' },
  { name: 'Knowledge', levelNumber: 10, pinPicture: 'LV10_Know.svg' },
  { name: 'Full Swing', levelNumber: 10, pinPicture: 'LV10_Full_Swing.svg' },
  { name: 'Around The Green', levelNumber: 10, pinPicture: 'LV10_ATG.svg' },
  { name: 'Overall', levelNumber: 10, pinPicture: 'LV10_Overall.svg' },
];

export const PlayerSessionServices = {
  sortFilterSearchSessions: async (
    request: playerSession.SortFilterSearchSessionsRequest,
  ): Promise<playerSession.SortFilterSearchSessionsResult> => {
    const response =
      await firebaseCloudFunctionService.getWithResponse<playerSession.SessionsLookupResponse>(
        PLAYER_SESSION_ENDPOINTS.LIST_SESSIONS,
        request,
      );
    const _data = response.data;
    return {
      sessions: _data,
      totalSessionRoster: parseTotalSessionRosterHeader(response.headers),
      totalNeedsClubs: parseTotalNeedsClubsHeader(response.headers),
      totalPinsArchived: parseTotalPinsArchivedHeader(response.headers),
    };
  },

  removeCoachFromSession: async (request: playerSession.EndSessionRequest): Promise<void> => {
    await firebaseCloudFunctionService.post(PLAYER_SESSION_ENDPOINTS.END_SESSION, request);
  },
  updatePlayerProgress: async (
    request: playerSession.UpdatePlayerProgressRequest,
  ): Promise<playerSession.UpdatePlayerProgressResponse> => {
    return await firebaseCloudFunctionService.post<
      playerSession.UpdatePlayerProgressResponse,
      playerSession.UpdatePlayerProgressRequest
    >(PLAYER_SESSION_ENDPOINTS.UPDATE_PLAYER_PROGRESS, request);
  },

  checkSessionForPlayerProgress: async (
    request: playerSession.CheckSessionForPlayerProgressRequest,
  ): Promise<playerSession.CheckSessionForPlayerProgressResponse> => {
    return await firebaseCloudFunctionService.post<
      playerSession.CheckSessionForPlayerProgressResponse,
      playerSession.CheckSessionForPlayerProgressRequest
    >(PLAYER_SESSION_ENDPOINTS.CHECK_SESSION_FOR_PLAYER_PROGRESS, request, {
      // iOS treats 409 as a valid response for this endpoint.
      validateStatus: status => (status >= 200 && status < 300) || status === 409,
    });
  },
};
